<template>
  <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="400px">
    <v-card>
      <v-card-title>
        <span class="headline">Duplicar plantilla de ordenes de compra</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="editTemplateForm" >
          <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-text-field
                  v-model="form.data.templateName"
                  :rules="validation.templateName"
                  label="Nombre de la plantilla"
                >
                </v-text-field>
              </v-flex>
              <v-flex
                xs12 md12 class="d-flex"
              >
                <v-select
                  :label="$t('recipes.labels.restaurant')"
                  v-model="form.data.restaurant"
                  :items="restaurants"
                  :rules="validation.restaurant"
                  item-text="name"
                  item-value="_id"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="mr-4"
          outlined
          rounded
          small
          depressed
          @click="closeDialog">
          Cerrar
        </v-btn>
        <v-btn
          color="success"
          class="mr-4"
          rounded
          small
          depressed
          @click="submit">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { required, string } from 'vue-mc/validation'
import { cloneDeep } from 'lodash'

export default {
  props: {
    template: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      form: {
        valid: false,
        data: {
          id: null,
          templateName: null,
          restaurant: null
        }
      },
      validation: {
        templateName: [required.and(string)]
      }
    }
  },
  computed: {
    restaurants: function () {
      return this.$store.state.login.restaurants.data || []
    }
  },
  watch: {
    template: async function (value) {
      const data = cloneDeep(value)
      this.form.data.id = data._id
      this.form.data.templateName = data.name
    }
  },
  methods: {
    async submit () {
      this.overlay = true
      try {
        const params = {
          name: this.form.data.templateName,
          restaurant: this.form.data.restaurant
        }
        await this.$api.post(`/v1/purchase-templates/${this.form.data.id}`, params)
        this.$toasted.show(`Se ha duplicado la plantilla con éxito.`, { duration: 3000 })
        this.closeDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    closeDialog () {
      this.isOpen = false
      this.$emit('close', false)
    },
    open () {
      this.isOpen = true
    }
  }
}
</script>
